import "../styles/globals.scss";
import "../public/icomoon/style.css";
import { useCookies } from "react-cookie";
import { I18nProvider } from "@lingui/react";
// import client from '../appolo-client';
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  useQuery,
} from "@apollo/client";
import RequiredLogin from "../component/Common/RequiredLogin";
import ClientOnly from "../component/LandingPage/ClientSide";
import NavBar from "../component/Common/Navbar";
import { ThemeProvider } from "@pmberjaya/cloudbank-ui";
import { i18n } from "@lingui/core";
import { useRouter } from "next/router";
import RequiredFillData from "../component/Common/RequiredFillData";
import { USER_INFO } from "../gql/user";
import { useMediaQuery } from "react-responsive";
import Layout from "../component/Common/Layout";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'

function MyApp({ Component, pageProps }) {
  const [cookie] = useCookies();
  const router = useRouter();
  i18n.activate("id");
  const client = new ApolloClient({
    uri: `${process.env.REACT_APP_GRAPHQL_URL}`,
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            billing_hosting: {
              carts: { merge: true },
            },
          },
        },
      },
    }),
    headers: {
      Authorization: `${
        cookie.access_token ? `Bearer ${cookie.access_token}` : ""
      }`,
    },
  });

  return (
    <ThemeProvider>
      <I18nProvider i18n={i18n}>
        <ApolloProvider client={client}>
          <ClientOnly>
            <NavBar />

            <Layout>
              <Component {...pageProps} />
            </Layout>
          </ClientOnly>
        </ApolloProvider>
      </I18nProvider>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default MyApp;
